/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Milestone_First_PrInputs */

const en_us2_milestone_first_pr = /** @type {(inputs: Milestone_First_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First personal record`)
};

const pt_br2_milestone_first_pr = /** @type {(inputs: Milestone_First_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeiro recorde pessoal`)
};

const es_419_milestone_first_pr = /** @type {(inputs: Milestone_First_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primer récord personal`)
};

const pt_pt2_milestone_first_pr = /** @type {(inputs: Milestone_First_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeiro recorde pessoal`)
};

const fr_fr2_milestone_first_pr = /** @type {(inputs: Milestone_First_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premier record personnel`)
};

const de_de2_milestone_first_pr = /** @type {(inputs: Milestone_First_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erster persönlicher Rekord`)
};

const it_it2_milestone_first_pr = /** @type {(inputs: Milestone_First_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primo record personale`)
};

/**
* | output |
* | --- |
* | "First personal record" |
*
* @param {Milestone_First_PrInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const milestone_first_pr = /** @type {((inputs?: Milestone_First_PrInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Milestone_First_PrInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_milestone_first_pr(inputs)
	if (locale === "es-419") return es_419_milestone_first_pr(inputs)
	if (locale === "pt-PT") return pt_pt2_milestone_first_pr(inputs)
	if (locale === "fr-FR") return fr_fr2_milestone_first_pr(inputs)
	if (locale === "de-DE") return de_de2_milestone_first_pr(inputs)
	if (locale === "it-IT") return it_it2_milestone_first_pr(inputs)
	return en_us2_milestone_first_pr(inputs)
});
export { milestone_first_pr as "milestone.first_pr" }